<template>
  <div class="p-24">
    <div class="mb-24">
      <RevIllustration
        alt=""
        class="rounded-md w-full object-cover"
        :height="240"
        role="presentation"
        sizes="327px"
        src="/img/product/jp/laptop_battery.jpg"
        :width="327"
      />
    </div>

    <h2 class="heading-2 mb-16 text-balance text-center">
      {{ i18n(translations.aboutBatteryHealth) }}
    </h2>

    <p class="mb-24">
      {{ i18n(translations.content1) }}
    </p>

    <p class="mb-24">
      {{ i18n(translations.content2) }}
    </p>

    <BatteryFaq :has-external-borders="false" />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevIllustration } from '@ds/components/Illustration'

import BatteryFaq from '~/scopes/product-core/components/presentationals/CustomizationFunnel/components/NewBatteryModal/components/BatteryFaq/BatteryFaq.vue'

import translations from '../../AboutBatteryModal.translations'

const i18n = useI18n()
</script>
